import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { UnidadesTiempo } from '../models/unidadesTiempo';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/UnidadesTiempo';

@Injectable({
  providedIn: 'root'
})
export class UnidadesTiempoService {
   
  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' });
  }

  save(entidad: UnidadesTiempo)
  {
    return this._http.post({ url: baseUrl + '/Save', body: entidad });
  }

  delete(id: number)
  {
    return this._http.get({ url: baseUrl + '/Delete?id=' + id});
  }

  calcularTiempoByUnidad(unidad: number, desde: Date, hasta: Date, personal: number): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/CalcularTiempoByUnidad?unidad=' + unidad + '&desde=' + desde + '&hasta=' + hasta + '&personal=' + personal})
  }
}
